import { Injectable } from '@rxdi/core';
import { Tab } from '@shared/tabs/tabs.component';
import { BehaviorSubject } from 'rxjs';

interface Menu {
  link: string;
  title: string;
}

@Injectable()
export class NavbarItemsProvider {
  private $menus: BehaviorSubject<Tab[]> = new BehaviorSubject([]);

  getMenus() {
    return this.$menus.asObservable();
  }

  setMenus(menus: Tab[]) {
    this.$menus.next(menus);
  }
}
